const DEFAULT_CRM_LABELS = {
  contact: { singular: 'Contact', plural: 'Contacts' },
  deal: { singular: 'Deal', plural: 'Deals' },
  organization: { singular: 'Organization', plural: 'Organizations' },
};

const merged = new WeakMap();

const crmLabels = (team) => {
  const teamLabels = team && team.crm_labels;
  if (!teamLabels || typeof teamLabels !== 'object') return DEFAULT_CRM_LABELS;
  if (!merged.has(teamLabels)) {
    const result = {};
    Object.keys(DEFAULT_CRM_LABELS).forEach((key) => {
      result[key] = { ...DEFAULT_CRM_LABELS[key], ...(teamLabels[key] || {}) };
    });
    merged.set(teamLabels, result);
  }
  return merged.get(teamLabels);
};

export default crmLabels;
